import React from 'react';
import JobsSection, { jobs, JobModal } from '../components/JobsSection';

function JobsPage({ path, navigate }) {
    const jobMatch = path.startsWith('/jobs/') ? jobs.find(j => j.slug === path.replace('/jobs/', '')) : null;

    function goJobs() {
        window.history.pushState({}, '', '/jobs');
        navigate('/jobs');
        window.scrollTo(0, 0);
    }

    function goHome() {
        window.history.pushState({}, '', '/');
        navigate('/');
        window.scrollTo(0, 0);
    }

    return (
        <div className="relative text-[#26251e] font-serif selection:bg-stone-200">
            {/* Fixed Video Background */}
            <video
                autoPlay
                loop
                muted
                playsInline
                className="fixed bottom-0 left-0 w-full h-[500px] object-cover -z-10"
            >
                <source src="/footer.mp4" type="video/mp4" />
            </video>
            <div className="fixed bottom-0 left-0 w-full h-[500px] bg-black/70 mix-blend-multiply -z-[5]"></div>
            <div className="fixed bottom-0 left-0 w-full h-[500px] flex flex-col justify-between px-8 md:px-16 pt-12 pb-20 -z-[4]">
                <div></div>
                <div className="text-white">
                    <h2 className="text-4xl md:text-6xl font-serif">Canopy Labs</h2>
                </div>
                <div className="text-white text-sm md:text-base font-sans"></div>
            </div>

            <div className="bg-white">
                {jobMatch ? (
                    <JobModal job={jobMatch} onClose={goJobs} />
                ) : (
                    <div className="max-w-[44rem] mx-auto px-6 pt-24 pb-16 md:px-0 md:pt-32 md:pb-16">
                        <button
                            onClick={goHome}
                            className="flex items-center gap-2 text-sm text-[#777777] hover:text-[#FB651F] transition-colors mb-12"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Back to home
                        </button>
                        <JobsSection />
                    </div>
                )}
            </div>

            <footer className="relative w-full min-h-[400px] bg-transparent"></footer>
        </div>
    );
}

export default JobsPage;
